import { render } from "./AfterSalesList.vue?vue&type=template&id=6d06e3c1&scoped=true"
import script from "./AfterSalesList.vue?vue&type=script&lang=js"
export * from "./AfterSalesList.vue?vue&type=script&lang=js"

import "./AfterSalesList.vue?vue&type=style&index=0&id=6d06e3c1&lang=scss&scoped=true"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d06e3c1"]])

export default __exports__